import { FrequentRiderPoints, FrequentRiderProgram } from "@graphql/api";
import TransactionTable from "./TransactionTable";
import useContent from "@lib/use_content";

interface FormProps {
  points?: FrequentRiderPoints[];
  programs?: FrequentRiderProgram[];
}

export default function Form({ points = [], programs = [] }: FormProps) {
  const { data, loading } = useContent(["beProfilePointsTitle"]);

  return (
    <div className="mt-8 mb-4 space-y-1">
      <h3 className="text-xl leading-6 font-bold text-gray-900 mb-4">
        {data?.content.beProfilePointsTitle}
      </h3>

      {points
        .filter((point) => Number(point.availablePoints) > 0)
        .map((point) => (
          <div key={point.id}>
            <span className="pr-2 text-gray-600 text-base">
              {programs.find((program) => Number(program.id) === point.programId)?.name}:
            </span>
            <span>{point.availablePoints} available points</span>
          </div>
        ))}

      <TransactionTable points={points} programs={programs} />
    </div>
  );
}
